export class User {
  idUser: number;
  userName: string;
  userMail: string;
  userNickname: string;
  userPassword: string;
  fkUserRole: number;
  fkUserState?: number;
  firstEntryDate?: Date;
  modificationDate?: Date;
  modificationUser?: number;
  lastEntryDate: string;
  temporalPassword?: boolean;
  passwordChangeDate?: Date;
  stateObservation: string;
  userToken: string;
  expiredPassword ?: boolean;
  idQuestion?: number;
  answer?: string;
  fkIdOffice?: number;
  fkAgentKey?: number;

}
